export default __webpack_public_path__ + "static/media/bootstrap.2800bb3e.png";